module.exports = __webpack_public_path__ + "static/media/shape01b.34a51fd0.svg";